import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message, Divider } from 'antd';
import api from '../../utils/api';

const ConsultationModal = ({ visible, onCancel, record, lang = 0, user, userCompanies }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && user) {
            form.setFieldsValue({
                name: user.username || '',
                mobile: user.mobile || '',
                contact: user.email || '' // Assuming contact can be email
            });
        }
    }, [visible, user]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const productName = `${record.product_alias || ""} / ${record.brand_alias || ""} / ${record.name || ""}`;
            const productLink = window.location.href;
            
            // Format customer contact info
            const contactInfo = `姓名: ${values.name || '-'}, 手机: ${values.mobile || '-'}, 其他: ${values.contact || '-'}`;
            
            // Format user companies
            let userCompaniesStr = "无";
            if (userCompanies && userCompanies.length > 0) {
                userCompaniesStr = userCompanies.map(c => c.alias || c.name || c.real_name || c.company_id).join(", ");
            }

            await api.post('/consultations', {
                productName,
                productLink,
                customerContact: contactInfo,
                message: values.message,
                userId: user?.id,
                username: user?.username,
                userCompanies: userCompaniesStr
            });

            message.success(lang === 0 ? '咨询提交成功' : 'Consultation submitted successfully');
            onCancel();
            form.resetFields();
        } catch (error) {
            console.error(error);
            message.error(lang === 0 ? '提交失败，请重试' : 'Submission failed, please try again');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={lang === 0 ? "实时联络" : "FastCheckIt!"}
            open={visible}
            onCancel={onCancel}
            onOk={handleSubmit}
            confirmLoading={loading}
            okText={lang === 0 ? "发送" : "Send"}
            cancelText={lang === 0 ? "取消" : "Cancel"}
        >
            <Form form={form} layout="vertical">
                <span style={{ color: 'var(--major-color)' }}>
                    {lang === 0 ? "请发送您的咨询内容，信息将被实时推送，工作人员在工作日时间将即刻联络或回复。" : "Please post your inquiry, our staff will reply to you soonest in real time during work day hours."}
                </span>
                <Divider />
                <Form.Item
                    name="name"
                    label={lang === 0 ? "称呼" : "Name"}
                    rules={[{ required: true, message: lang === 0 ? "请输入您的称呼" : "Please enter your name" }]}
                >
                    <Input placeholder={lang === 0 ? "怎么称呼您" : "Your Name"} />
                </Form.Item>
                <Form.Item
                    name="mobile"
                    label={lang === 0 ? "手机号" : "Mobile"}
                    rules={[{ required: true, message: lang === 0 ? "请输入手机号" : "Please enter your mobile number" }]}
                >
                    <Input placeholder={lang === 0 ? "联系电话" : "Mobile Number"} />
                </Form.Item>
                <Form.Item
                    name="contact"
                    label={lang === 0 ? "其他联系方式 (邮箱/微信)" : "Other Contact (Email/WeChat)"}
                >
                    <Input placeholder={lang === 0 ? "选填" : "Optional"} />
                </Form.Item>
                <Form.Item
                    name="message"
                    label={lang === 0 ? "咨询内容" : "Message"}
                    rules={[{ required: true, message: lang === 0 ? "请输入咨询内容" : "Please enter your message" }]}
                >
                    <Input.TextArea rows={4} placeholder={lang === 0 ? "例如：我想了解该产品的价格和库存..." : "E.g., I would like to know the price and stock..."} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ConsultationModal;
